import axios from 'axios';

// Dedicated axios instance for NOC Operations endpoints.
const nocApi = axios.create({ baseURL: '/api/noc', withCredentials: true });

nocApi.interceptors.request.use(cfg => {
  const token = localStorage.getItem('flowup_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

nocApi.interceptors.response.use(
  res => res.data,
  err => {
    if (err.response?.status === 401) {
      const onLogin = window.location.pathname === '/login';
      if (!onLogin) {
        localStorage.removeItem('flowup_token');
        window.dispatchEvent(new CustomEvent('auth:logout'));
        setTimeout(() => { window.location.replace('/login'); }, 100);
      }
    }
    return Promise.reject(err.response?.data || { error: err.message });
  }
);

nocApi.get = (url, config) => nocApi({ method: 'get', url, ...config });
nocApi.post = (url, data, config) => nocApi({ method: 'post', url, data, ...config });
nocApi.put = (url, data, config) => nocApi({ method: 'put', url, data, ...config });
nocApi.delete = (url, config) => nocApi({ method: 'delete', url, ...config });

export default nocApi;
